import { Group, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { useOnline } from '@/shared/hooks/useOnline';

import { Icon } from './Icon';

/**
 * "Sin conexión: no se está guardando" (`AM-132 point 13`, D17, ISO-18): the PWA promises no
 * offline work, so this is how the UI says so instead of letting a write fail silently. Mounted
 * once in each shell (console and portal); with a connection it shows nothing.
 *
 * The polite live region (`role="status"`) is in the page from the start, empty and with no height
 * (as in `NewVersionBar`), and the banner is written into it only while offline: a screen reader
 * announces a change inside a region it already knows, not reliably one that enters the page with
 * its text.
 */
export function OfflineBanner() {
  const { t } = useTranslation('common');
  const online = useOnline();

  return (
    <div role="status">
      {online ? null : (
        <Group
          gap="xs"
          justify="center"
          py={6}
          style={{
            background: 'var(--mantine-color-orange-1)',
            borderBottom: '1px solid var(--mantine-color-orange-4)',
          }}
        >
          <Icon name="wifiOff" size={16} />
          <Text size="sm" fw={600} c="orange.9">
            {t('offline.banner')}
          </Text>
        </Group>
      )}
    </div>
  );
}
